import { Outlet } from 'react-router-dom'
import { Bike, Package, Wallet } from 'lucide-react'

export default function AuthLayout() {
  return (
    <div className="min-h-screen flex">
      {/* Left Side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-primary relative overflow-hidden">
        {/* Decorative circles */}
        <div className="absolute top-20 left-20 w-64 h-64 bg-accent rounded-full opacity-20"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-accent rounded-full opacity-10"></div>
        <div className="absolute top-1/2 left-1/4 w-32 h-32 bg-white rounded-full opacity-10"></div>

        {/* Content */}
        <div className="relative z-10 flex flex-col justify-center items-center w-full p-12 text-white">
          <img
            src="/images/Umenda.svg"
            alt="Umenda Logo"
            className="h-20 w-auto mb-8 brightness-0 invert"
          />
          <h1 className="text-4xl font-bold mb-4 text-center">Rider Portal</h1>
          <p className="text-lg text-center text-white/80 max-w-md">
            Deliver with confidence. Track your earnings, manage orders, and grow your income.
          </p>

          {/* Features */}
          <div className="mt-12 grid grid-cols-3 gap-8 text-center">
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 bg-accent/20 rounded-full flex items-center justify-center mb-3">
                <Bike className="w-6 h-6 text-accent" />
              </div>
              <div className="text-sm text-white/70">Fast Deliveries</div>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 bg-accent/20 rounded-full flex items-center justify-center mb-3">
                <Package className="w-6 h-6 text-accent" />
              </div>
              <div className="text-sm text-white/70">Real-time Orders</div>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 bg-accent/20 rounded-full flex items-center justify-center mb-3">
                <Wallet className="w-6 h-6 text-accent" />
              </div>
              <div className="text-sm text-white/70">Instant Payouts</div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - Auth Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-md">
          {/* Mobile Logo */}
          <div className="lg:hidden text-center mb-8">
            <div className="flex items-center justify-center mb-4">
              <img
                src="/images/Umenda.svg"
                alt="Umenda Logo"
                className="h-12 w-auto"
              />
            </div>
            <h2 className="text-xl font-bold text-gray-900">Rider Portal</h2>
          </div>

          {/* Auth Form Content */}
          <div className="bg-white">
            <Outlet />
          </div>

          {/* Footer */}
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500">
              Protected by enterprise-grade security
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}